/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useContext, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { PAGE_TITLE, ROUTE_TYPE } from '../../Configuration'
import { PascodeMetadata } from '../../assets/ts/data/pascode-metadata'
import { PointsOfContact } from '../../assets/ts/data/points-of-contact'
import { twoDigits } from '../../assets/ts/formatting/formatting'
import {
  formatPhoneNumber,
  generateCodeOptionOnLength,
  generateSquadronOptions,
  getFilteredItems,
  getMAJCOMCode,
  getSquadrons,
  getUniqueCodes,
} from '../../assets/ts/general/general'
import Buttons from '../../components/buttons/buttons'
import usePageTitle from '../../hooks/use-page-title'
import usePascodeMetadata from '../../hooks/use-pascode-metadata'
import usePointsOfContacts from '../../hooks/use-points-of-contact'
import PageHeader from '../../layouts/header/page-header'
import { MetadataContext } from '../../store/metadata-context-provider'
import { PreviousPageContext } from '../../store/previous-page-provider'
import { RoleContext } from '../../store/role-context-provider'
import { UserContext } from '../../store/user-context-provider'
import {
  ALL_SELECT_LABEL,
  ALL_SELECT_OPTION,
  ALL_SELECT_VALUE,
  ALL_SELECT_VALUE_STRING,
} from '../../utils/constants/global-constants'
import NO_RESULTS from '../../utils/constants/no-results'
import CustomSelect from '../../utils/controls/custom-select'
import { Dropdown, optionsTypes } from '../../utils/controls/select-options-data'
import './poc.css'

interface IntialInputValues {
  componentValue: number
  majcomValue: number
  sectionValue: number
  squadronValue: string
}

const PointsOfContacts = () => {
  usePageTitle(PAGE_TITLE.POINTS_OF_CONTACTS)
  const navigate = useNavigate()
  const location = useLocation()

  const { pointsOfContact } = usePointsOfContacts({
    isArchivedFilter: false,
  })
  const { componentOptions, majcomOptions, majcoms, sectionOptions } = useContext(MetadataContext)
  const { userProfile } = useContext(UserContext)

  const {
    initialInquiryAndDueoutFilter,
    isAssignedComponentOwner,
    isCPOwner,
    isCSS,
    isCustomer,
    isLeadership,
    isMAJCOMOwner,
    isMPFOwner,
    isSectionChief,
    isSectionOwner,
    isSiteAdmin,
    isSupervisor,
    isTechnician,
  } = useContext(RoleContext)
  const userLoginRole = {
    CSSPASCODEFilter: initialInquiryAndDueoutFilter?.cssPASCODES,
    usersAssignedComponentCode: initialInquiryAndDueoutFilter?.assignedComponentCodeFilter,
    usersMajcomCodeFilter: initialInquiryAndDueoutFilter?.majcomCodeFilter,
    usersSectionCodeFilter: initialInquiryAndDueoutFilter?.sectionCodeFilter,
    usersServicingOrganizationFilter: initialInquiryAndDueoutFilter?.servicingOrganizationFilter,
    usersServicingOrganizationWithoutSectionFilter:
      initialInquiryAndDueoutFilter?.servicingOrganizationWithoutSectionFilter,
  }
  const [filteredPointsOfContact, setFilteredPointsOfContact] = useState<PointsOfContact[]>([])

  const [inputValues, setInputValues] = useState({
    assignedComponentCode: location.state?.filterValues?.assignedComponentCode
      ? location.state.filterValues.assignedComponentCode
      : ALL_SELECT_VALUE,
    itemKey: location.state?.itemKey ? location.state?.itemKey : '',
    majcomCode: location.state?.filterValues?.majcomCode
      ? location.state.filterValues.majcomCode
      : ALL_SELECT_VALUE,
    sectionCode: location.state?.filterValues?.sectionCode
      ? location.state.filterValues.sectionCode
      : ALL_SELECT_VALUE,
    squadron: location.state?.filterValues?.squadron
      ? location.state.filterValues.squadron
      : ALL_SELECT_VALUE_STRING,
  })
  const { currentPage, setCurrentPage, setPreviousPage } = useContext(PreviousPageContext)
  const [intialInputValues, setIntialInputValues] = useState<IntialInputValues>({
    componentValue: ALL_SELECT_VALUE,
    majcomValue: ALL_SELECT_VALUE,
    sectionValue: ALL_SELECT_VALUE,
    squadronValue: ALL_SELECT_VALUE_STRING,
  })
  const [intialComponentDropdown, setIntialComponentDropdown] = useState<optionsTypes[]>([
    ALL_SELECT_OPTION,
  ])
  const [intialMajcomDropdown, setIntialMajcomDropdown] = useState<optionsTypes[]>([
    ALL_SELECT_OPTION,
  ])
  const [intialSquadronDropdown, setIntialSquadronDropdown] = useState<optionsTypes[]>([
    ALL_SELECT_OPTION,
  ])
  const [intialSectionDropdown, setIntialSectionDropdown] = useState<optionsTypes[]>([
    ALL_SELECT_OPTION,
  ])
  const [majcomDropDown, setMajcomDropdown] = useState<optionsTypes[]>([])
  const [squadronDropDown, setSquadronDropDown] = useState<optionsTypes[]>([])

  const { pascodeMetadata } = usePascodeMetadata({
    IsArchived: false,
  })

  const formatShortName = (firstName: string, lastName: string) => {
    if (firstName && lastName) return firstName[0] + lastName[0]
  }

  const onClear = () => {
    setIntialComponentDropdown(intialComponentDropdown)
    setMajcomDropdown(intialMajcomDropdown)
    setIntialSectionDropdown(intialSectionDropdown)
    setSquadronDropDown(intialSquadronDropdown)
    
    setInputValues({
      assignedComponentCode: intialInputValues.componentValue,
      itemKey: '',
      majcomCode: intialInputValues.majcomValue,
      sectionCode: intialInputValues.sectionValue,
      squadron: intialInputValues.squadronValue,
    })
  }

  useEffect(() => {
    const filteredPOC = pointsOfContact.filter(
      (POCEntry) =>
        (inputValues.assignedComponentCode === -1 ||
          !POCEntry.AssignedComponentCode ||
          POCEntry.AssignedComponentCode === inputValues.assignedComponentCode) &&
        (inputValues.majcomCode === -1 ||
          !POCEntry.ServicingMAJCOMCode ||
          POCEntry.ServicingMAJCOMCode === inputValues.majcomCode) &&
        (inputValues.sectionCode === -1 ||POCEntry.SectionCodes.length === 0 ||
          POCEntry.SectionCodes?.some((sec) => sec === inputValues.sectionCode)) &&
        (inputValues.squadron === '' ||
          !POCEntry.Squadron ||
          POCEntry.Squadron === inputValues.squadron)
    )
    setFilteredPointsOfContact(filteredPOC)
  }, [pointsOfContact, inputValues])

  const setintialOptions = (
    componentOptions: optionsTypes[],
    majcomOptions: optionsTypes[],
    squadronOptions: optionsTypes[],
    sectionOptions: optionsTypes[],
    ownerIntialMajcom?: optionsTypes[],
    ownerIntialSqudronOptions?: optionsTypes[]
  ) => {
    const componentValue = userProfile[0].AssignedComponentCode
    const servicingMAJCOMCode = getMAJCOMCode(userProfile[0].ServicingMAJCOM, majcoms)
    const squadronValue = userProfile[0].ServicingOrganization.replace('MPF', 'FSS')
    setIntialComponentDropdown(componentOptions)
    setIntialMajcomDropdown(majcomOptions)
    setMajcomDropdown(ownerIntialMajcom ? ownerIntialMajcom : majcomOptions)
    setIntialSquadronDropdown(
      ownerIntialSqudronOptions ? ownerIntialSqudronOptions : squadronOptions
    )
    setSquadronDropDown(squadronOptions)
    setIntialSectionDropdown(sectionOptions)
    const dropdownValues = {
      assignedComponentCode: componentValue,
      majcomCode: servicingMAJCOMCode,
      sectionCode: sectionOptions.length === 1 ? sectionOptions[0].value : ALL_SELECT_VALUE,
      squadron: squadronValue,
    }
    if (!location.state?.filterValues) {
      setInputValues((prev) => ({
        ...prev,
        ...dropdownValues,
      }))
      setIntialInputValues({
        componentValue: dropdownValues.assignedComponentCode as number,
        majcomValue: dropdownValues.majcomCode as number,
        sectionValue: dropdownValues.sectionCode as number,
        squadronValue: dropdownValues.squadron as string,
      })
    }
  }
  useEffect(() => {
    const assignedComponentOptions = componentOptions.filter(
      ({ value }) => value !== ALL_SELECT_VALUE
    )
    if (isCPOwner || isSiteAdmin) {
      const profileComponentCode = userProfile[0].AssignedComponentCode
      const majcomCodes = majcoms
        .filter((item) => item.ParentComponentCode === profileComponentCode)
        .map((item) => item.MAJCOMCode)
      const majcomOption = generateCodeOptionOnLength(majcomOptions, majcomCodes)
      const squadrons = getSquadrons(
        pascodeMetadata,
        undefined,
        undefined,
        userProfile[0].ServicingMAJCOM
      )
      const ownerIntialSqudron = getSquadrons(pascodeMetadata)
      const ownerIntialSqudronOptions = generateSquadronOptions(ownerIntialSqudron)
      const squdronsOptions = generateSquadronOptions(squadrons)
      setintialOptions(
        assignedComponentOptions,
        majcomOptions,
        squdronsOptions,
        sectionOptions,
        majcomOption,
        ownerIntialSqudronOptions
      )
    } else if (isAssignedComponentOwner) {
      const componentCodes = userLoginRole?.usersAssignedComponentCode
      const assignedComponentCodeOptions = generateCodeOptionOnLength(
        assignedComponentOptions,
        componentCodes
      )
      const majcomCodes = majcoms
        .filter((item) => componentCodes?.includes(item.ParentComponentCode))
        .map((item) => item.MAJCOMCode)
      const majcomOption = generateCodeOptionOnLength(majcomOptions, majcomCodes)
      const ownerSquadrons = getSquadrons(pascodeMetadata, undefined, componentCodes)
      const ownerSqudronsOptions = generateSquadronOptions(ownerSquadrons)
      const squadrons = getSquadrons(
        pascodeMetadata,
        undefined,
        componentCodes,
        userProfile[0].ServicingMAJCOM
      )
      const squdronsOptions = generateSquadronOptions(squadrons)
      setintialOptions(
        assignedComponentCodeOptions,
        majcomOption,
        squdronsOptions,
        sectionOptions,
        undefined,
        ownerSqudronsOptions
      )
    } else if (isMAJCOMOwner) {
      const majcomCode = userLoginRole?.usersMajcomCodeFilter
      const profileMajcomCode = getMAJCOMCode(userProfile[0].ServicingMAJCOM, majcoms)
      const majcomCodes = majcomCode.includes(profileMajcomCode)
        ? majcomCode
        : (majcomCode.unshift(profileMajcomCode), majcomCode)

      const componentCodes = majcoms
        .filter((item) => majcomCodes?.includes(item.MAJCOMCode))
        .map((item) => item.ParentComponentCode)
      const assignedComponentCodeOptions = generateCodeOptionOnLength(
        assignedComponentOptions,
        componentCodes
      )
      const majcomOption = generateCodeOptionOnLength(majcomOptions, majcomCodes)
      const majcomNames = majcoms
        .filter((item) => majcomCodes?.includes(item.MAJCOMCode))
        .map((item) => item.Label)
      const squadrons = getSquadrons(
        pascodeMetadata,
        undefined,
        undefined,
        userProfile[0].ServicingMAJCOM
      )
      const squdronsOptions = generateSquadronOptions(squadrons)
      const ownerSquadrons = getSquadrons(
        pascodeMetadata,
        undefined,
        undefined,
        undefined,
        majcomNames
      )
      const ownerSqudronsOptions = generateSquadronOptions(ownerSquadrons)
      setintialOptions(
        assignedComponentCodeOptions,
        majcomOption,
        squdronsOptions,
        sectionOptions,
        undefined,
        ownerSqudronsOptions
      )
    } else if (isLeadership || isMPFOwner) {
      const roleOrganizations =
        userLoginRole?.usersServicingOrganizationWithoutSectionFilter as string[]
      const profileOrganization = userProfile[0].ServicingOrganization
      const organizations = roleOrganizations.includes(profileOrganization)
        ? roleOrganizations
        : (roleOrganizations.unshift(profileOrganization), roleOrganizations)
      const filteredItems: PascodeMetadata[] = getFilteredItems(pascodeMetadata, organizations)
      const { componentCodes, servicingMAJCOMS } = getUniqueCodes(filteredItems)
      const majcomCodes = servicingMAJCOMS.map((item) => getMAJCOMCode(item, majcoms))
      const assignedComponentCodeOptions = generateCodeOptionOnLength(
        assignedComponentOptions,
        componentCodes
      )
      const majcomOption = generateCodeOptionOnLength(majcomOptions, majcomCodes)
      const squadrons = getSquadrons(
        pascodeMetadata,
        undefined,
        undefined,
        userProfile[0].ServicingMAJCOM,
        undefined,
        organizations
      )

      const squdronsOptions = generateSquadronOptions(squadrons)
      const ownerSqudronsOptions = generateSquadronOptions(organizations)
      setintialOptions(
        assignedComponentCodeOptions,
        majcomOption,
        squdronsOptions,
        sectionOptions,
        undefined,
        ownerSqudronsOptions
      )
    } else if (isCSS) {
      const userCSSPASCODES = userLoginRole?.CSSPASCODEFilter
      const userProfilePASCODE = userProfile[0].PASCODE
      const cssPASCODES = userCSSPASCODES.includes(userProfilePASCODE)
        ? userCSSPASCODES
        : (userCSSPASCODES.unshift(userProfilePASCODE), userCSSPASCODES)
      const filteredItems = pascodeMetadata.filter((item) => cssPASCODES?.includes(item.PASCODE))
      const { componentCodes, organizations, servicingMAJCOMS } = getUniqueCodes(filteredItems)
      const majcomCodes = servicingMAJCOMS.map((item) => getMAJCOMCode(item, majcoms))
      const assignedComponentCodeOptions = generateCodeOptionOnLength(
        assignedComponentOptions,
        componentCodes
      )
      const majcomOption = generateCodeOptionOnLength(majcomOptions, majcomCodes)
      const squadrons = getSquadrons(
        pascodeMetadata,
        undefined,
        undefined,
        userProfile[0].ServicingMAJCOM,
        undefined,
        organizations
      )
      const squdronsOptions = generateSquadronOptions(squadrons)
      const ownerSqudronsOptions = generateSquadronOptions(organizations)
      setintialOptions(
        assignedComponentCodeOptions,
        majcomOption,
        squdronsOptions,
        sectionOptions,
        undefined,
        ownerSqudronsOptions
      )
    } else if (isSupervisor || isTechnician || isSectionChief || isSectionOwner) {
      const roleOrganizations = userLoginRole?.usersServicingOrganizationFilter as string[]
      const profileOrganization = userProfile[0].ServicingOrganization
      const organizations = roleOrganizations.includes(profileOrganization)
        ? roleOrganizations
        : (roleOrganizations.unshift(profileOrganization), roleOrganizations)
      const filteredItems = getFilteredItems(pascodeMetadata, organizations)
      const { componentCodes, servicingMAJCOMS } = getUniqueCodes(filteredItems)
      const majcomCodes = servicingMAJCOMS.map((item) => getMAJCOMCode(item, majcoms))
      const assignedComponentCodeOptions = generateCodeOptionOnLength(
        assignedComponentOptions,
        componentCodes
      )
      const majcomOption = generateCodeOptionOnLength(majcomOptions, majcomCodes)
      const squadrons = getSquadrons(
        pascodeMetadata,
        undefined,
        undefined,
        userProfile[0].ServicingMAJCOM,
        undefined,
        organizations
      )
      const squdronsOptions = generateSquadronOptions(squadrons)
      const ownerSqudronsOptions = generateSquadronOptions(organizations)

      const sectionCodes = userLoginRole?.usersSectionCodeFilter as number[]
      const sectionOption = generateCodeOptionOnLength(sectionOptions, sectionCodes)
      setintialOptions(
        assignedComponentCodeOptions,
        majcomOption,
        squdronsOptions,
        sectionOption,
        undefined,
        ownerSqudronsOptions
      )
    } else {
      const componentCode = [userProfile[0].AssignedComponentCode]
      const servicingMAJCOMCode = [getMAJCOMCode(userProfile[0].ServicingMAJCOM, majcoms)]
      const assignedComponentCodeOptions = generateCodeOptionOnLength(
        assignedComponentOptions,
        componentCode
      )
      const majcomOption = generateCodeOptionOnLength(majcomOptions, servicingMAJCOMCode)
      const organizations = [userProfile[0].ServicingOrganization]
      const squdronsOptions = generateSquadronOptions(organizations)

      setintialOptions(assignedComponentCodeOptions, majcomOption, squdronsOptions, sectionOptions)
    }
  }, [
    isSiteAdmin,
    isCSS,
    isCPOwner,
    isAssignedComponentOwner,
    isMAJCOMOwner,
    pascodeMetadata,
    isCustomer,
  ])
  const pointsofcontactItems = filteredPointsOfContact.map((pocitems: any) => (
    <div className=' col-xxl-3 col-md-6 col-sm-12 mt-0 mb-3 ' key={pocitems.DutyTitle}>
      <div className='bordered8 p-2 border-radius d-flex mb-3 h-100 align-items-center poclist'>
        <div className='POC-thumb m-0 me-2 align-items-center d-flex justify-content-center'>
          {formatShortName(
            pocitems.PointOfContact.properties.firstName,
            pocitems.PointOfContact.properties.lastName
          )}
        </div>

        {/* <div className='m-0 me-2 align-items-center d-flex justify-content-center '>
          <img alt='user' src={pocavtar} tabIndex={0} title='user' />
        </div> */}
        <div>
          <p
            aria-label={pocitems.PointOfContact.properties.defaultDisplay}
            className='m-0 font-12 title-color2 poppins-semibold'
            tabIndex={0}
          >
            {pocitems.PointOfContact.properties.defaultDisplay}
          </p>
          <p
            aria-label={pocitems.DutyTitle}
            className='m-0 font-11 poppins-medium title-color21'
            tabIndex={0}
          >
            {pocitems.DutyTitle}
          </p>
          <p className='m-0'>
            <span className='icon-mail'></span>
            <a
              className='eMail font-12 sourcesanspro color-primary ms-1'
              href='mailto:{pocitems.Title}'
              title={pocitems.Title}
            >
              {pocitems.Title}
            </a>
          </p>
          <p className='m-0'>
            <span className='icon-phone'></span>
            <a
              className='phone font-12 sourcesanspro ms-1 color-primary'
              href='tel:{pocitems.PhoneNumber}'
              title={pocitems.PhoneNumber}
            >
              {formatPhoneNumber(pocitems.PhoneNumber)}
            </a>
          </p>
        </div>
      </div>
    </div>
  ))

  const onAssignComponentChange = (e: { label: string; value: number }) => {
    const option: Dropdown[] = majcoms
      .filter(({ ParentComponentCode }) => ParentComponentCode === e.value)
      .map(({ Label, Value }) => ({ label: Label, value: Value }))
    const intialmajcomCodes = intialMajcomDropdown.map(({ value }) => value)
    const options = option.filter(({ value }) => intialmajcomCodes.includes(value as number))
    if (options.length > 1) options.unshift(ALL_SELECT_OPTION)
    setMajcomDropdown(options as optionsTypes[])
    // organization
    const pascodes = pascodeMetadata.filter(
      ({ AssignedComponentCode }) => AssignedComponentCode === e.value
    )
    const intialSquadron = intialSquadronDropdown.map(({ value }) =>
      (value as string).replace('FSS', 'MPF')
    )
    const squadrons = [
      ...new Set(
        pascodes
          .filter(({ ServicingOrganization }) =>
            intialSquadron.includes(ServicingOrganization as string)
          )
          .map(({ ServicingOrganization }) => ServicingOrganization)
      ),
    ].sort()
    const squdronsOptions = generateSquadronOptions(squadrons)
    setSquadronDropDown(squdronsOptions as optionsTypes[])
    const squadronValue =
      squdronsOptions.length === 1 ? (squdronsOptions[0].value as string) : ALL_SELECT_VALUE_STRING

    setInputValues((prev) => ({
      ...prev,
      assignedComponentCode: e.value,
      majcomCode: options.length === 1 ? options[0].value : ALL_SELECT_VALUE,
      section: -1,
      squadron: squadronValue,
    }))
  }
  const onMajcomChange = (e: { label: string; value: number }) => {
    const pascodes =
      e.label === ALL_SELECT_LABEL
        ? pascodeMetadata
        : pascodeMetadata.filter(({ ServicingMAJCOM }) => ServicingMAJCOM === e.label)
    const intialSquadron = intialSquadronDropdown.map(({ value }) =>
      (value as string).replace('FSS', 'MPF')
    )
    const squdrons = [
      ...new Set(
        pascodes
          .filter(({ ServicingOrganization }) =>
            intialSquadron.includes(ServicingOrganization as string)
          )
          .map(({ ServicingOrganization }) => ServicingOrganization)
      ),
    ].sort()
    const squdronsOptions = generateSquadronOptions(squdrons)
    setSquadronDropDown(squdronsOptions as optionsTypes[])
    const squadronValue =
      squdronsOptions.length === 1 ? (squdronsOptions[0].value as string) : ALL_SELECT_VALUE_STRING
    setInputValues((prevState) => ({
      ...prevState,
      majcomCode: e.value,
      section: -1,
      squadron: squadronValue,
    }))
  }

  const onSquadronChange = (e: { label: string; value: number }) => {
    setInputValues((prevState) => ({
      ...prevState,
      section: -1,
      squadron: e.value,
    }))
  }

  const onSectionChange = (e: { label: string; value: number }) => {
    setInputValues((prevState) => ({
      ...prevState,
      sectionCode: e.value,
    }))
  }

  const redirectToHome = () => {
    navigate(`${ROUTE_TYPE}`)
  }

  useEffect(() => {
    // This effect runs whenever the location changes (when the user navigates to a different route)
    if (currentPage !== location.pathname) {
      // User has navigated to a new page, so update the previous page
      setPreviousPage(currentPage) // Store the previous page
      setCurrentPage(location.pathname) // Update the current page
    }
  }, [location, currentPage]) // Runs whenever location or currentPage changes

  return (
    <>
      <PageHeader
        count={twoDigits(filteredPointsOfContact.length)}
        extras={
          <div className='d-flex flex-wrap align-items-center'>
            <div className='mx-2 mb-1'>
              <CustomSelect
                className='form-sm w-100 max-w-sm-200 min-w-sm-200  sourcesanspro font-13 customselect'
                formClassName='form-horizontal dash poppins-semibold font-12 title-color'
                id='AssignedComponent'
                inputProps={{
                  className: 'font-12 poppins-medium title-color',
                }}
                label='Assigned Component'
                name='Assigned Component'
                onChange={onAssignComponentChange}
                options={intialComponentDropdown}
                value={inputValues.assignedComponentCode}
              />
            </div>
            <div className='mx-2 mb-1'>
              <CustomSelect
                className='form-sm w-100 max-w-sm-100 min-w-sm-100  sourcesanspro font-13 customselect'
                formClassName='form-horizontal dash poppins-semibold font-12 title-color'
                id='ServicingMAJCOM'
                inputProps={{
                  className: 'font-12 poppins-medium title-color',
                }}
                label='Servicing MAJCOM'
                name='Servicing MAJCOM'
                onChange={onMajcomChange}
                options={majcomDropDown}
                value={inputValues.majcomCode}
              />
            </div>
            <div className='mx-2 mb-1'>
              <CustomSelect
                className='form-sm w-100 max-w-sm-100 min-w-sm-100  sourcesanspro font-13 customselect'
                formClassName='form-horizontal dash poppins-semibold font-12 title-color'
                id='ServicingOrganization'
                inputProps={{
                  className: 'font-12 poppins-medium title-color',
                }}
                label='Servicing Organization'
                name='Servicing Organization'
                onChange={onSquadronChange}
                options={squadronDropDown}
                value={inputValues.squadron}
              />
            </div>
            <div className='mx-2 mb-1'>
              <CustomSelect
                className='form-sm w-100 max-w-sm-100 min-w-sm-100  sourcesanspro font-13 customselect'
                formClassName='form-horizontal dash poppins-semibold font-12 title-color'
                id='Section'
                inputProps={{
                  className: 'font-12 poppins-medium title-color',
                }}
                label='Section'
                name='Section'
                onChange={onSectionChange}
                options={intialSectionDropdown}
                value={inputValues?.sectionCode}
              />
            </div>

            <div className='ms-2 mb-1 ms-auto'>
              <Buttons
                className='btn btn-sm links ms-auto ms-sm-0 ms-md-0 p-0 links-underline'
                label='Clear All'
                onClick={(e: any) => onClear()}
                type='button'
              />
            </div>
            <div className='mx-2 mb-1 d-none'>
              <Buttons
                aria-label='Back'
                className='btn-sm font-14 btn-bgcolor7 whitetext  border-radius text-uppercase'
                icon='icon-left-arrow me-1 font-10'
                label='Back'
                onClick={(e: any) => redirectToHome()}
              />
            </div>
          </div>
        }
        icon='icon-poc font-14 me-1 color-primary'
        name='Points Of Contacts'
      />
      <div className='container'>
        <div className='mt-3 card shadow '>
          <div className='whitebg border-radius2 p-3 '>
            {filteredPointsOfContact.length > 0 ? (
              <div className='font-13 pe-1 row'>{pointsofcontactItems}</div>
            ) : (
              <div>
              <NO_RESULTS/>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  )
}
export default PointsOfContacts
